import React from 'react';
import ReactDOM from 'react-dom/client';

// Self-hosted fonts (latin subset only) — no runtime Google Fonts request.
// Jost: headings/display. Nunito Sans: body. JetBrains Mono stays as-is.
import '@fontsource/jost/latin-400.css';
import '@fontsource/jost/latin-700.css';
import '@fontsource/jost/latin-700-italic.css';
import '@fontsource/nunito-sans/latin-400.css';
import '@fontsource/nunito-sans/latin-500.css';
import '@fontsource/nunito-sans/latin-600.css';
import '@fontsource/nunito-sans/latin-700.css';

import { App } from '@/app';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
